<fieldset>
  <legend class="keyLabel">Performance Outputs</legend>
  @if (response()) {
    <div class="content">
      @if (response().ErrorMessage) {
        <div class="errorMessage">
          {{ response().ErrorMessage }}
        </div>
      }
      <div class="detailRow">
        <label class="displayLabel">Airflow:</label>
        <label class="displayValue">{{ response().Airflow | number: '1.0-2' }}</label>
        <label class="unitLabel">{{ getAirflowUnits() }}</label>
        @if (response().CircuitResponse?.OutputPower) {
          <span>
            <label class="displayLabel">Power:</label>
            <label class="displayValue">{{ response().CircuitResponse.OutputPower }}</label>
            <label class="unitLabel">Watts</label>
          </span>
        }
        @if (response().CircuitResponse?.HorsepowerValue) {
          <span>
            <label class="displayLabel">BHP:</label>
            <label class="displayValue">{{ response().CircuitResponse.HorsepowerValue }}</label>
          </span>
        }
        @if (response().CircuitResponse?.FullLoadAmps) {
          <span>
            <label class="displayLabel">FLA:</label>
            <label class="displayValue">{{ response().CircuitResponse.FullLoadAmps }}</label>
          </span>
        }
      </div>
      <div class="detailRow">
        @if (response().PrimaryCoilResponse) {
          <div class="coilRatingContainer">
            <app-schedule-line-performance-coil-output [response]="response().PrimaryCoilResponse"
              [isHeat]="!response().primaryCooling" [isSureflow]="isSureflow()"
              [fieldLabel]="'Primary Coil'" [isMetric]="isMetric()">
            </app-schedule-line-performance-coil-output>
          </div>
        }
        @if (response().SecondaryCoilResponse) {
          <div class="coilRatingContainer">
            <app-schedule-line-performance-coil-output [response]="response().SecondaryCoilResponse"
              [isHeat]="true" [isSureflow]="isSureflow()"
              [fieldLabel]="'Secondary Coil'" [isMetric]="isMetric()">
            </app-schedule-line-performance-coil-output>
          </div>
        }
        <div class="coilRatingContainer">
          @if (response().ElectricHeatResponse) {
            <div>
              <app-schedule-line-performance-coil-output [response]="response().ElectricHeatResponse"
                [isHeat]="true"
                [fieldLabel]="'Electric Heat'" [isMetric]="isMetric()">
              </app-schedule-line-performance-coil-output>
            </div>
          }
          @if (response().PrimaryDrivePackage || response().SecondaryDrivePackage) {
            <div class="stackedResponse">
              <app-drive-package-wrapper [response]="response()"></app-drive-package-wrapper>
            </div>
          }
        </div>
      </div>
    </div>
  }
</fieldset>
